<script setup>
import { computed } from 'vue'
import { DxButton } from 'devextreme-vue/button'
import { getI18n } from '@/plugins/i18n'

const i18n = getI18n()

const props = defineProps({
  masterEntityId: Number,
  grid: Object,
  entityLock: Object,
  onBeforeClick: Function,
  hint: {
    type: String,
    default: null,
  }
})

const isLockedByAnother = computed(() => {
  if (props.masterEntityId == null) return false

  return props.entityLock?.isLocked(false, props.masterEntityId)
})

const onClick = () => {
  let valid = true
  if (props.onBeforeClick) {
    valid = props.onBeforeClick()
    if (!valid) return
  }

  const gridInstance = props.grid?.instance
  if (!gridInstance || !gridInstance._$element?.length) return

  gridInstance.addRow()
}
</script>
<template>
  <slot>
    <DxButton
      v-if="!isLockedByAnother"
      icon="add"
      :hint="props.hint || i18n.t('common.add')"
      styling-mode="text"
      type="normal"
      class="dx-datagrid-addrow-button"
      @click="onClick"
    />
  </slot>
</template>

